import React from 'react';
import { Calendar, MessageCircle, BedDouble } from 'lucide-react';
import { FadeInUp, BounceIn } from './ScrollAnimationWrapper';

const Rooms = ({ language = 'de', openBooking, setCurrentPage }) => {
  
  const translations = {
    de: {
      title: 'Unsere Zimmer',
      subtitle: 'Einzelbett- und Doppelbettzimmer',
      bookRoom: 'Zimmer Buchen',
      contactUs: 'Kontakt Aufnehmen',
      bookingInfo: 'Reservierung über unseren Kalender',
      contactInfo: 'Haben Sie Fragen? Kontaktieren Sie uns!'
    },
    en: {
      title: 'Our Rooms',
      subtitle: 'Single and Double Bed Rooms',
      bookRoom: 'Book a Room',
      contactUs: 'Contact Us',
      bookingInfo: 'Make reservations through our calendar',
      contactInfo: 'Have questions? Contact us!'
    }
  };

  const t = translations[language];

  return (
    <section id="rooms" className="py-16 md:py-20 bg-luxury-charcoal">
      <div className="container-custom">
        
        {/* Section Header */}
        <FadeInUp threshold={0.1} className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-3">
            {t.title}
          </h2>
          <div className="w-16 h-0.5 bg-luxury-gold mx-auto mb-4" />
          <p className="text-lg text-luxury-cream max-w-xl mx-auto">
            {t.subtitle}
          </p>
        </FadeInUp>

        {/* Elegant Rooms Showcase */}
        <div className="max-w-4xl mx-auto">
          <BounceIn delay={200} threshold={0.1}>
            <div className="bg-gradient-to-br from-luxury-slate/80 via-luxury-charcoal/60 to-luxury-slate/80 backdrop-blur-lg rounded-2xl p-6 md:p-8 shadow-xl border border-luxury-gold/30 overflow-hidden">
              
              <div className="text-center mb-8">
                {/* Elegant Icon */}
                <div className="flex justify-center mb-6">
                  <div className="relative">
                    <div className="bg-gradient-to-br from-luxury-gold to-luxury-darkGold rounded-xl p-4 shadow-lg">
                      <BedDouble className="text-white" size={32} strokeWidth={1.5} />
                    </div>
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-2xl md:text-3xl font-display font-bold text-white drop-shadow-lg mb-4">
                  {language === 'de' 
                    ? 'Unsere Zimmer' 
                    : 'Our Rooms'}
                </h3>

                {/* Description */}
                <p className="text-sm md:text-base text-luxury-cream max-w-2xl mx-auto mb-6 font-serif leading-relaxed">
                  {language === 'de'
                    ? 'Wir bieten Ihnen komfortable Einzelbett- und Doppelbettzimmer für einen erholsamen Aufenthalt in ruhiger Atmosphäre.'
                    : 'We offer comfortable single and double bed rooms for a relaxing stay in a peaceful atmosphere.'}
                </p>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mb-6">
                  
                  {/* Book Room Button */}
                  <button
                    onClick={() => openBooking && openBooking('room')}
                    className="group relative bg-gradient-to-r from-luxury-gold to-luxury-darkGold hover:from-luxury-darkGold hover:to-luxury-gold text-white px-6 py-3 rounded-full font-semibold text-base transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center"
                  >
                    <Calendar className="mr-2 group-hover:animate-pulse" size={18} />
                    {t.bookRoom}
                  </button>

                  {/* Contact Button */}
                  <button
                    onClick={() => setCurrentPage && setCurrentPage('contact')}
                    className="group relative border-2 border-luxury-gold text-luxury-gold hover:bg-luxury-gold hover:text-white px-6 py-3 rounded-full font-semibold text-base transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center"
                  >
                    <MessageCircle className="mr-2 group-hover:animate-pulse" size={18} />
                    {t.contactUs}
                  </button>
                </div>

                {/* Info Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
                  <div className="bg-luxury-slate/40 backdrop-blur-sm rounded-xl p-4 border border-luxury-gold/40 shadow-lg">
                    <Calendar className="text-luxury-gold mx-auto mb-2" size={24} />
                    <h4 className="font-semibold text-white mb-1 text-sm">{t.bookingInfo}</h4>
                    <p className="text-xs text-luxury-cream">
                      {language === 'de'
                        ? 'Nutzen Sie unseren integrierten Kalender für eine einfache und schnelle Reservierung.'
                        : 'Use our integrated calendar for easy and quick reservations.'}
                    </p>
                  </div>
                  
                  <div className="bg-luxury-slate/40 backdrop-blur-sm rounded-xl p-4 border border-luxury-gold/40 shadow-lg">
                    <MessageCircle className="text-luxury-gold mx-auto mb-2" size={24} />
                    <h4 className="font-semibold text-white mb-1 text-sm">{t.contactInfo}</h4>
                    <p className="text-xs text-luxury-cream">
                      {language === 'de'
                        ? 'Unser Team steht Ihnen jederzeit für Fragen und spezielle Wünsche zur Verfügung.'
                        : 'Our team is always available for questions and special requests.'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </BounceIn>
        </div>

      </div>
    </section>
  );
};

export default Rooms;
